import React, { useState } from 'react';
import axios from 'axios';
import { Switch } from './ui/switch';
import { useSiteSettings, setSiteSettingsCache } from '../hooks/useSiteSettings';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InventoryToggle = () => {
  const settings = useSiteSettings();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const on = settings?.inventory_enabled ?? false;

  const change = async (value) => {
    setSaving(true);
    setError(false);
    try {
      const res = await axios.put(`${API}/admin/settings`, { inventory_enabled: value }, { withCredentials: true });
      setSiteSettingsCache(res.data);
    } catch {
      setError(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <label className="flex items-center gap-2 text-sm text-white/90 bg-white/10 rounded-lg px-3 py-1.5 cursor-pointer" data-testid="inventory-visibility-toggle">
      <span>Inventaire en ligne</span>
      <Switch checked={on} disabled={saving || !settings} onCheckedChange={change} data-testid="inventory-visibility-switch" />
      <span className={`font-bold ${on ? 'text-green-300' : 'text-red-300'}`} data-testid="inventory-visibility-status">{on ? 'ON' : 'OFF'}</span>
      {error && <span className="text-red-300 text-xs" data-testid="inventory-visibility-error">Erreur</span>}
    </label>
  );
};
